import React from 'react';
import { observer } from 'mobx-react';
import ContractListFilter from './ContractListFilter';
import ContractListService from '../services/ContractListService';

class ContractListFilterContainer extends React.Component {
  render() {
    return (
      <ContractListFilter
        onSearch={ContractListService.load}
        values={ContractListService.form.getValues()}
        onChange={ContractListService.form.setValue}
      />
    );
  }
}

export default observer(ContractListFilterContainer);
